import ajax from '../../common/services/httpService'
import { localeData } from '../../common/services/localeService'
import { REPORT_GRAINS } from '../consts/executiveReportKpis'

export const EXECUTIVE_REPORT_PERMISSION = 'executive-report'

/**
 * @param {{ roles?: string[] } | null | undefined} user
 * @returns {boolean}
 */
export function canExportExecutiveReport(user) {
	return Array.isArray(user?.roles) && user.roles.includes(EXECUTIVE_REPORT_PERMISSION)
}

/**
 * @param {Object} filter - panel filter with site + time
 * @param {string} [language] - panel locale at export time; defaults to the stored UI language
 * @param {{
 * grain?: 'month'|'week',
 * reportMonth?: string,
 * reportMonthFrom?: string,
 * compareMonth?: string,
 * reportWeek?: string,
 * compareWeek?: string,
 * weekStartsOn?: string,
 * comparison?: boolean,
 * reportShifts?: string, comma-separated shift ids
 * }} [period]
 * @returns {Promise<Object>}
 */
export async function getExecutiveReport(filter, language, period = {}) {
	const params = {
		...filter,
		...period,
		language: language || localeData.language || 'en',
		grain: period.grain || REPORT_GRAINS.MONTH,
	}
	return ajax.get('stats/performance/executive-report', null, params)
}

/**
 * Calendar months the site has stats for, oldest first.
 * @param {number|string} siteId
 * @returns {Promise<Array<{ year: number, month: number, key: string }>>}
 */
export async function getExecutiveReportMonths(siteId) {
	if (siteId == null || siteId === '') return []
	const data = await ajax.get(`stats/site/${siteId}/executive-report-months`)
	return data?.months || []
}

/**
 * Calendar weeks the site has stats for, oldest first, snapped to the requested week start.
 * @param {number|string} siteId
 * @param {string} [weekStartsOn] 'sunday' | 'monday'
 * @returns {Promise<Array<{ key: string, timeFrom: string, timeTo: string }>>}
 */
export async function getExecutiveReportWeeks(siteId, weekStartsOn = 'sunday') {
	if (siteId == null || siteId === '') return []
	const data = await ajax.get(`stats/site/${siteId}/executive-report-weeks`, null, { weekStartsOn })
	return data?.weeks || []
}

export default {
	EXECUTIVE_REPORT_PERMISSION,
	canExportExecutiveReport,
	getExecutiveReport,
	getExecutiveReportMonths,
	getExecutiveReportWeeks,
}
